import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { resolveAssetUrl } from "@/lib/api";
import { toast } from "sonner";
import { useSite } from "@/context/SiteContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Loader2, Lock, Mail, ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { content } = useSite();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("dc_token", data.access_token);
      localStorage.setItem("dc_email", data.email);
      toast.success("Login realizado!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao entrar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="page-admin-login" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1A1858] via-[#2E2A8C] to-[#0a0a2e] p-6 relative overflow-hidden">
      <div className="absolute inset-0 tech-grid opacity-30"></div>
      <div className="glow-orb w-[500px] h-[500px] -top-32 -right-32 bg-dc-accent/30"></div>

      <div className="relative w-full max-w-md">
        <div className="bg-white rounded-3xl p-8 md:p-10 shadow-2xl">
          <div className="flex items-center gap-3 mb-7">
            <img src={resolveAssetUrl(content?.logo_url_light, "/brand/logo-light.png")} alt="DeskcodeBR" className="h-10 w-auto" />
            <div className="border-l border-slate-200 pl-3">
              <div className="text-xs text-slate-500 uppercase tracking-wider">Painel administrativo</div>
            </div>
          </div>
          <h1 className="font-heading text-2xl font-bold text-dc-text mb-2">Acesso restrito</h1>
          <p className="text-sm text-slate-500 mb-7">Entre com suas credenciais de administrador.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-sm">E-mail</Label>
              <div className="relative mt-2">
                <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <Input data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="pl-10" placeholder="admin@deskcodebr.com.br" />
              </div>
            </div>
            <div>
              <Label className="text-sm">Senha</Label>
              <div className="relative mt-2">
                <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                <Input data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="pl-10" placeholder="Sua senha" />
              </div>
            </div>
            <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full bg-dc-primary hover:bg-dc-primary-hover text-white py-6 rounded-full font-semibold">
              {loading ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Entrando...</> : <><ShieldCheck className="w-4 h-4 mr-2" /> Entrar</>}
            </Button>
          </form>
        </div>

        <div className="text-center mt-6 text-xs text-blue-100/70">
          Protegido por JWT • LGPD compliant
        </div>
      </div>
    </div>
  );
}
